"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/ThirtySpeedLimit.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ThirtySpeedLimit = function ThirtySpeedLimit(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 184.7 184.7"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Speed Limit Icon"), _react2.default.createElement("path", {
    className: "sign",
    d: "M92.3 184.7c-51 0-92.3-41.3-92.3-92.3S41.3 0 92.3 0s92.3 41.3 92.3 92.3-41.3 92.3-92.3 92.4zm0-166.9c-41.2 0-74.5 33.4-74.5 74.5s33.4 74.5 74.5 74.5 74.5-33.4 74.5-74.5-33.3-74.4-74.5-74.5z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "numbers",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "three",
    d: "M37.5 109.8l14.2-1.7c.5 3.6 1.7 6.4 3.7 8.3 1.9 1.9 4.5 2.9 7.2 2.9 2.9 0 5.7-1.2 7.7-3.4 2.1-2.3 3.1-5.4 3.1-9.3 0-3.7-1-6.6-3-8.8-1.8-2.1-4.5-3.3-7.3-3.2-2.3.1-4.6.4-6.7 1.1l1.6-12c4 .1 7-.8 9.1-2.6 2.1-1.8 3.2-4.5 3.1-7.3.3-4.4-3-8.1-7.3-8.5h-1.1c-2.4 0-4.7.9-6.4 2.6-1.8 1.7-2.9 4.3-3.2 7.6l-13.5-2.2c.7-3.9 2.1-7.7 4.3-11.1 2-2.9 4.7-5.1 7.9-6.5 3.6-1.6 7.5-2.4 11.4-2.4 7.2 0 13 2.3 17.3 6.9C83 63.6 85 68.1 85 72.9 85 79.6 81.3 85 74 89c4.1.8 7.9 3 10.5 6.3 2.7 3.4 4.1 7.6 3.9 11.9.1 6.5-2.6 12.8-7.4 17.2-4.9 4.7-11.5 7.3-18.3 7.1-6.9 0-12.7-2-17.2-6-4.6-4.1-7.5-9.6-8-15.7z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "zero",
    d: "M122.3 53.2c7.4 0 13.2 2.6 17.4 7.9 5 6.3 7.5 16.7 7.5 31.2s-2.5 24.9-7.5 31.2c-4.1 5.2-9.9 7.8-17.3 7.8-7 .2-13.7-3-18-8.6-4.6-5.7-6.8-15.9-6.8-30.6 0-14.4 2.5-24.8 7.5-31.1 4-5.1 9.8-7.8 17.2-7.8zm0 12.2c-1.7 0-3.4.6-4.8 1.7s-2.5 3.2-3.2 6.1c-1 3.8-1.5 10.2-1.5 19.2s.5 15.2 1.4 18.5c.9 3.3 2 5.6 3.4 6.7 2.8 2.2 6.7 2.2 9.5 0 1.4-1.1 2.5-3.2 3.2-6.1 1-3.8 1.5-10.1 1.5-19.1s-.5-15.2-1.4-18.5c-.9-3.3-2-5.6-3.4-6.7-1.3-1.2-2.9-1.8-4.7-1.8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: undefined
  })));
};
exports.default = ThirtySpeedLimit;